import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 update_tenant_order_status: { message: "idle" },
};

export const update_tenant_order_status_Slice = createSlice({
 name: "update_tenant_order_status",
 initialState,
 reducers: {
  success_update_tenant_order_status: (state, action) => {
   state.update_tenant_order_status = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_update_tenant_order_status: (state, action) => {
   state.update_tenant_order_status = { status: app_consts.FAIL, message: action.payload };
  },
  reset_update_tenant_order_status: (state) => {
   state.update_tenant_order_status = { status: app_consts.IDLE };
  },
  loading_update_tenant_order_status: (state) => {
   state.update_tenant_order_status = { status: app_consts.LOADING };
  },
 }
});

export const { success_update_tenant_order_status, fail_update_tenant_order_status, reset_update_tenant_order_status, loading_update_tenant_order_status } = update_tenant_order_status_Slice.actions;

export default update_tenant_order_status_Slice.reducer;